import { InjectionToken } from "@angular/core";

// Outside the generated client, which imports it from here, so app.module can provide it eagerly (PROXY-7).
export const STATISTICS_API_BASE_URL = new InjectionToken<string>("STATISTICS_API_BASE_URL");
